import { useCallback } from "react";
import { useHistory } from "react-router-dom";
import { useEditAccessGroupModal } from "@/react/components/shared/AccessGroups/EditAccessGroupModal";
import { communitiesPaths } from "@/react/helpers/routerPathHelpers";
import { useChecklistApi } from "./useChecklistApi";

export const useDefaultAccessGroup = () => {
  const history = useHistory();
  const gettingStartedPath = communitiesPaths.onboarding();

  const { show: showEditAccessGroupModal } = useEditAccessGroupModal();
  const { fetchDefaultAccessGroup } = useChecklistApi();

  const openEditAccessGroupModal = useCallback(() => {
    void fetchDefaultAccessGroup(undefined, {
      onSuccess: group => {
        void showEditAccessGroupModal({
          accessGroup: group,
          onClose: () => history.push(gettingStartedPath),
        });
      },
    });
  }, [
    fetchDefaultAccessGroup,
    showEditAccessGroupModal,
    history,
    gettingStartedPath,
  ]);

  return { openEditAccessGroupModal };
};
